export default __webpack_public_path__ + "static/media/positive.04154088.svg";